<template>
    <b-row>
        <b-col class="px-2">
            <b-overlay :show="loading" rounded="sm" opacity="0.60" spinner-variant="primary">
                <div class="content-pipu d-flex justify-content-center align-items-center">
                    <b-card
                        v-if="!loading"
                        class="p-0 shadow-none"
                        no-body
                    >
                        <b-card-text class="text-30">Obrigado pela sua participação!</b-card-text>
                        <div class="mt-3">
                            <b-button
                                class="btn-icon btn-response btn-no-hover"
                                :key="response"
                                variant="outline-light"
                            >
                                <response-emoji
                                    :response="response"
                                    :hasText="true"
                                    size="30px"
                                />
                            </b-button>
                            <span class="ml-3 text-16 lh-lg">
                                Gostaria de fazer um
                                <router-link
                                    :to="{ name: 'Comment' }"
                                    tag="a"
                                    class="text-muted"
                                >
                                    <u>comentário</u>
                                </router-link>?
                            </span>
                        </div>
                    </b-card>
                </div>
            </b-overlay>
        </b-col>
    </b-row>
</template>

<script>
import api from '@/api/api'
export default {
    name: 'Response',
    components: {
        ResponseEmoji: () => import('@/components/Emojis/ResponseEmoji'),
    },
    data () {
        return {
            pulse: '',
            response: null,
            uid: '',
            loading: false,
        }
    },
    methods: {
        answer () {
            if (this.loading) return
            this.loading = true

            api
                .post(`/response/${this.pulse}/${this.uid}/${this.response}`)
                .then((response) => {
                    this.loading = false
                })
        },
    },
    created () {
        this.pulse = this.$route.params.pulse
        this.response = +this.$route.params.response
        this.uid = this.$route.params.uid

        this.answer()
    },
}
</script>
<style lang="scss">
    .btn-response {
        color: #47404f;
        min-width: 140px;
        &.btn-no-hover {
            box-shadow: unset;
            background-color: #fff;
        }
    }
    @media (max-width(var(--breakpoint-sm))) {
        .container {
            margin: 0.5rem;
        }
    }
    @media (min-width(var(--breakpoint-sm))) and (max-width(var(--breakpoint-xl))){
        .container {
            margin: 0.5rem 1rem;
        }
    }
    @media (min-width(var(--breakpoint-xl))) {
        .container {
            margin: 0.5rem 3rem;
        }
    }

    .content-pipu {
        height: 33rem;
    }
</style>
